import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';

import childrenOfTypes from '../../utils/childrenOfTypes';
import ActionMenuItem from './ActionMenuItem';
import ActionMenuDiver from './ActionMenuDivider';

export const ActionMenuWithButton = ({
  children,
  id,
  label,
  bsStyle,
  disabled,
  ariaLabel,
  menuRight,
  noCaret,
}) => (
  <Dropdown
    pullRight={menuRight}
    id={id}
    className="ActionMenuWithButton"
    disabled={disabled}
  >
    <Dropdown.Toggle
      bsStyle={bsStyle}
      aria-label={ariaLabel || label}
      noCaret={noCaret}
    >
      {label}
    </Dropdown.Toggle>
    <Dropdown.Menu>
      {children}
    </Dropdown.Menu>
  </Dropdown>
);

ActionMenuWithButton.propTypes = {
  children: childrenOfTypes(ActionMenuItem, ActionMenuDiver).isRequired,
  id: PropTypes.string,
  ariaLabel: PropTypes.string,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]).isRequired,
  /** Disable button */
  disabled: PropTypes.bool,
  noCaret: PropTypes.bool,
  /** To align the menu to the right side of the Dropdown toggle  */
  menuRight: PropTypes.bool,
  /** Button style */
  bsStyle: PropTypes.oneOf(['default', 'primary', 'success', 'info', 'warning', 'danger', 'link']),
};

ActionMenuWithButton.defaultProps = {
  id: null,
  disabled: false,
  bsStyle: 'default',
  ariaLabel: '',
  menuRight: false,
  noCaret: false,
};

export default ActionMenuWithButton;
